import { SYMBOLS_PALETTE } from '@/constants';
export function rgbaToHex(rgba: {
  r: number;
  g: number;
  b: number;
  a?: number;
}) {
  const { r, g, b, a } = rgba;
  const hex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
  const alphaHex =
    a === 1 || a === undefined
      ? ''
      : Math.round(a * 255)
          .toString(16)
          .padStart(2, '0');

  return `#${hex}${alphaHex}`;
}

export function determineAssetColor(symbol: string) {
  let assetSymbol = symbol;
  if (assetSymbol.startsWith('PT')) {
    const parts = assetSymbol.split('-');
    assetSymbol = parts[1];
  }

  return SYMBOLS_PALETTE[assetSymbol] || '#ffffff';
}
